<form [formGroup]="form" class="table-filters">
  <div class="left f-row">
    <div class="search-input-wrapper f-col">
      <div class="search-wrapper">
        <app-icon icon="search" class="large-icon"></app-icon>
        <input class="custom-input search-input small-reg-text" matInput
          formControlName="keywords"
          placeholder="Search Supervisors">
        </div>
      </div>
      @if (enableInactive) {
        <div class="checkbox-wrapper f-row">
          <input type="checkbox" class="isSelected" name="isSelected" formControlName="showInactive" aria-labelledby="checkboxLabel">
          <label class="small-reg-text checkboxLabel" id="checkboxLabel">Include Inactive</label>
        </div>
      }
    </div>
  </form>
